// POPUP
function coOpenMobileMenu() {
    const openBtn = document.querySelector('#co-size-guide-open-button-id');
    const closeBtn = document.querySelector('#co-size-guide-close-button-id');
    const mobileMenu = document.querySelector('#co-size-guide-id');
    if (openBtn && closeBtn && mobileMenu) {
        mobileMenu.classList.add('co-active');
        closeBtn.classList.add('co-active');
        openBtn.classList.remove('co-active');
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('co-body-active');
    }
}
function coCloseMobileMenu() {
    const openBtn = document.querySelector('#co-size-guide-open-button-id');
    const closeBtn = document.querySelector('#co-size-guide-close-button-id');
    const mobileMenu = document.querySelector('#co-size-guide-id');
    if (openBtn && closeBtn && mobileMenu) {
        mobileMenu.classList.remove('co-active');
        closeBtn.classList.remove('co-active');
        openBtn.classList.add('co-active');
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('co-body-active');
    }
}
const openBtn = document.querySelector('#co-size-guide-open-button-id');
const closeBtn = document.querySelector('#co-size-guide-close-button-id');
const overlay = document.querySelector('#co-size-guide-overlay-id');

if (openBtn) {
    openBtn.addEventListener('click', coOpenMobileMenu);
}
if (closeBtn) {
    closeBtn.addEventListener('click', coCloseMobileMenu);
}
if (overlay) {
    overlay.addEventListener('click', coCloseMobileMenu);
}
// TABS
document.querySelectorAll('.co-size-guide-tabs').forEach(tabContainer => {
  const tabButtons = tabContainer.querySelectorAll('.co-size-guide-tab-btn');
  const tabContents = tabContainer.querySelectorAll('.co-size-guide-tab-cntnt');
  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      activateTab(index);
    });
    button.addEventListener('keydown', (e) => {
      let newIndex = index;
      if (e.key === 'ArrowRight') {
        newIndex = (index + 1) % tabButtons.length;
      } else if (e.key === 'ArrowLeft') {
        newIndex = (index - 1 + tabButtons.length) % tabButtons.length;
      }
      if (newIndex !== index) {
        tabButtons[newIndex].focus();
        activateTab(newIndex);
      }
    });
  });
  function activateTab(index) {
    tabButtons.forEach((btn, idx) => {
      btn.classList.remove('co-active');
      btn.setAttribute('aria-selected', 'false');
      tabContents[idx].classList.remove('co-active');
    });
    tabButtons[index].classList.add('co-active');
    tabButtons[index].setAttribute('aria-selected', 'true');
    tabContents[index].classList.add('co-active');
  }
});

